/* Rova gift wrap + handwritten note, inside the UpCart slide-out cart.
   Ticked items are wrapped together as ONE gift: one "Gift Wrap & Handwritten Note" ($4) per order,
   saved on the order as cart attributes "Gift wrap" (which items, e.g. "Japan, Pen + marker set") and "Gift note".
   Gift wrap + priority processing are US-only (hidden for other countries). */
(function () {
  var GIFT_VARIANT = 60089710248222;
  var PRIORITY_VARIANT = 60089924354334;   /* "Priority Processing" $3, one per order */
  function isAddon(i) { return i.variant_id === GIFT_VARIANT || i.variant_id === PRIORITY_VARIANT; }
  var EXAMPLES = {
    Japan: "Please don't spend all your money at 7-Eleven. xo, Jen",
    Italy: "Buon viaggio! Can't wait to hear everything. Love, Jen",
    France: "Bon voyage! Eat all the croissants. xo, Mom",
    Bali: "For all the stories you're about to collect. Love, Mom"
  };
  var FALLBACK = "Get lost. Then write about it. xo, Jen";
  var ACCENT = "rgb(188, 91, 108)";

  var state = { on: false, items: {}, pri: false, note: "" };   // items[key] = { c: ticked }
  var loadedFromCart = false;
  var busy = false;
  var noteTimer = null;
  var cartAttrs = {};
  if (window.__rovaGiftLoaded) return;
  window.__rovaGiftLoaded = true;
  /* Sticky bar buttons: hover = a slightly darker shade of the journal's own color (GemPages defaulted it to purple) */
  (function () {
    var st = document.createElement("style"); st.id = "rova-sticky-hover";
    st.textContent = 'gp-sticky .gp-button-atc{--hvr-bg:color-mix(in srgb,var(--bg) 88%,#000)!important}';
    (document.head || document.documentElement).appendChild(st);
  })();
  /* Desktop menu doesn't depend on the cart app, so build it as soon as the page is ready */
  function navWhenReady(tries) { if (!buildDesktopNav() && tries < 20) setTimeout(function () { navWhenReady(tries + 1); }, 300); }
  function mnavWhenReady(tries) { if (!buildMobileNav() && tries < 20) setTimeout(function () { mnavWhenReady(tries + 1); }, 300); }
  function startNavs() { navWhenReady(0); mnavWhenReady(0); footerWhenReady(0); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", startNavs); else setTimeout(startNavs, 0);

  function root() { var h = document.getElementById("upCart"); return h && h.shadowRoot; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nameOf(item) {
    var n = (item.product_title || item.title || "").split(" - ")[0].trim();
    return n.charAt(0).toUpperCase() + n.slice(1).toLowerCase();
  }
  function getCart() { return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function refresh() { if (window.upcartRefreshCart) window.upcartRefreshCart(); }

  /* One gift slot per journal copy: 2 Japan + 1 Italy -> "Japan #1", "Japan #2", "Italy" */
  function unitsFor(journals) {
    var counts = {}, order = [];
    journals.forEach(function (i) {
      var n = nameOf(i);
      if (!(n in counts)) { counts[n] = 0; order.push(n); }
      counts[n] += i.quantity;
    });
    var units = [];
    order.forEach(function (n) {
      var q = counts[n];
      if (q === 1 && state.items[n + " #1"] && !state.items[n]) { state.items[n] = state.items[n + " #1"]; }
      if (q > 1 && state.items[n] && !state.items[n + " #1"]) { state.items[n + " #1"] = state.items[n]; }
      for (var k = 1; k <= q; k++) units.push({ key: q === 1 ? n : n + " #" + k, name: n });
    });
    var keep = {};
    units.forEach(function (u) { keep[u.key] = true; });
    Object.keys(state.items).forEach(function (k) { if (!keep[k]) delete state.items[k]; });
    return units;
  }

  function isUS() { var c = window.Shopify && window.Shopify.country; return !c || c === "US"; }
  function pickedUnits(units) {
    return state.on ? units.filter(function (u) { var it = state.items[u.key]; return it && it.c; }) : [];
  }
  function exampleFor(units) {
    var p = pickedUnits(units);
    for (var i = 0; i < p.length; i++) if (EXAMPLES[p[i].name]) return EXAMPLES[p[i].name];
    return FALLBACK;
  }
  function attrsFor(units) {
    var a = {}, picked = pickedUnits(units).map(function (u) { return u.key; });
    Object.keys(cartAttrs).forEach(function (k) { if (k.indexOf("Gift note - ") === 0) a[k] = ""; });   /* clear old per-item notes */
    a["Gift wrap"] = picked.join(", ");
    a["Gift note"] = picked.length ? (state.note || "") : "";
    return { attrs: a, count: picked.length ? 1 : 0 };
  }

  /* Add-ons (gift wrap, priority processing) live in the add-on card, not the item list */
  function hideGiftRowControls(sr) {
    sr.querySelectorAll('[class*="ProductRow__product__"]').forEach(function (row) {
      var t = row.querySelector(".upcart-product-title");
      var addon = !!(t && /gift wrap|priority processing/i.test(t.textContent));
      if (addon && row.style.display !== "none") row.style.display = "none";
      if (!addon && row.style.display === "none") row.style.display = "";
    });
  }

  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  function drawSavings(sr, cart, anchor) {
    var old = sr.getElementById("rova-savings"); if (old) old.remove();
    if (!cart.total_discount) return null;
    var titles = [];
    cart.items.forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (d) {
        var t = d.discount_application && d.discount_application.title;
        if (t && titles.indexOf(t) < 0) titles.push(t);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.title && titles.indexOf(d.title) < 0) titles.push(d.title); });
    var s = document.createElement("div");
    s.id = "rova-savings";
    s.innerHTML = '<span>Bundle savings' + (titles.length ? ' <span class="code">' + esc(titles.join(", ")) + '</span>' : '') + '</span><span class="amt">−' + money(cart.total_discount) + '</span>';
    anchor.parentNode.insertBefore(s, anchor.nextSibling);
    return s;
  }

  function draw() {
    var sr = root(); if (!sr) return;
    var anchor = sr.querySelector(".upcart-products-section"); if (!anchor) return;
    getCart().then(function (cart) {
      cartAttrs = cart.attributes || {};
      setFabCount(cart);
      var journals = cart.items.filter(function (i) { return !isAddon(i); });

      if (!loadedFromCart) {
        loadedFromCart = true;
        var picked = (cartAttrs["Gift wrap"] || "").split(", ").filter(Boolean);
        if (picked.length) state.on = true;
        picked.forEach(function (k) { state.items[k] = { c: true }; });
        state.note = cartAttrs["Gift note"] || (picked[0] && cartAttrs["Gift note - " + picked[0]]) || "";
      }
      state.pri = cart.items.some(function (i) { return i.variant_id === PRIORITY_VARIANT; });
      var units = unitsFor(journals);
      var us = isUS();
      if (!us) { state.on = false; state.pri = false; }
      var single = units.length === 1;
      if (single) { state.items[units[0].key] = { c: state.on }; }

      var old = sr.getElementById("rova-gift"); if (old) old.remove();
      hideGiftRowControls(sr);
      var after = drawSavings(sr, cart, anchor) || anchor;

      var giftLine = cart.items.filter(function (i) { return i.variant_id === GIFT_VARIANT; })[0];
      var have = giftLine ? giftLine.quantity : 0;
      var want = attrsFor(units).count;
      if (!units.length) { state.pri = false; }
      if (have !== want || (!units.length && cart.items.some(function (i) { return i.variant_id === PRIORITY_VARIANT; }))) { reconcile(units); }
      if (!units.length || !us) return;

      var w = document.createElement("div");
      w.id = "rova-gift";
      var ICON_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8.5" width="17" height="4" rx="1"/><path d="M5 12.5v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7M12 8.5v12"/><path d="M12 8.5S10.5 4 8.2 4.6C6.4 5.1 7 8.5 12 8.5zM12 8.5s1.5-4.5 3.8-3.9c1.8.5 1.2 3.9-3.8 3.9z"/></svg>';
      var ICON_PLANE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 3 10.5 13.5"/><path d="M21 3l-6.5 18-4-7.5L3 9.5 21 3z"/></svg>';
      w.innerHTML =
        '<style>' +
        '#rova-gift{margin:14px 16px;padding:0 16px;border:1px solid #EAE3DB;border-radius:12px;background:#fff;font-size:14px;color:#2B2623}' +
        '#rova-gift,#rova-gift *{font-family:"Zalando Sans SemiExpanded",Assistant,sans-serif!important;letter-spacing:.3px}' +
        '#rova-gift .row{padding:14px 0}#rova-gift .row+.row{border-top:1px solid #F0E9E2}' +
        '#rova-gift label{display:flex;align-items:center;gap:10px;cursor:pointer}' +
        '#rova-gift .top .t{font-size:14.5px;font-weight:600}' +
        '#rova-gift .top .ic{display:flex;color:#8F8076;margin-right:auto}#rova-gift .top .ic svg{width:16px;height:16px}' +
        '#rova-gift .top .p{font-size:13.5px;font-weight:600;color:' + ACCENT + '}' +
        '#rova-gift .sub{font-size:12.5px;color:rgba(43,38,35,.65);margin:4px 0 0 27px}' +
        '#rova-gift .sub .hl{display:inline-block;margin-top:5px;font-weight:600;color:' + ACCENT + '}' +
        '#rova-gift input[type=checkbox]{width:17px;height:17px;accent-color:' + ACCENT + ';margin:0;flex:none}' +
        '#rova-gift .it{margin:10px 0 0 27px}#rova-gift .it label{font-size:13.5px}' +
        '#rova-gift .tog{font-size:12px;margin:10px 0 0 27px;color:' + ACCENT + '}' +
        '#rova-gift .msg{font-size:12px;font-weight:600;margin:12px 0 4px 27px;opacity:.8}' +
        '#rova-gift .err{display:none;margin:6px 0 0 27px;font-size:12px;font-weight:600;color:#B3261E}' +
        '#rova-gift .g-n.bad .err{display:block}#rova-gift .g-n.bad textarea{border-color:#B3261E!important}' +
        '#rova-gift textarea{display:block;margin-left:27px;width:calc(100% - 27px);box-sizing:border-box;border:1px solid #d9cfcf;border-radius:8px;padding:8px;font-size:13.5px;min-height:54px;resize:vertical;background:#fff;color:inherit}' +
        '</style>' +
        '<div class="row">' +
        '<label class="top"><input type="checkbox" class="g-on"' + (state.on ? " checked" : "") + '><span class="t">This is a gift</span><span class="ic">' + ICON_GIFT + '</span><span class="p">+$4</span></label>' +
        '<div class="sub">Add gift wrap and a handwritten note.</div>' +
        '<div class="g-body" style="display:' + (state.on ? "block" : "none") + '">' +
        units.map(function (u) {
          var it = state.items[u.key] || {};
          return '<div class="it" data-k="' + esc(u.key) + '"' + (single ? ' style="display:none"' : '') + '>' +
            '<label><input type="checkbox" class="g-c"' + (it.c ? " checked" : "") + '> ' + esc(u.key) + '</label></div>';
        }).join("") +
        (single ? '' : '<div class="tog">Checked items are wrapped together as one gift.</div>') +
        '<div class="g-n">' +
        '<div class="msg">Add a message</div>' +
        '<textarea maxlength="250" placeholder="' + esc(exampleFor(units)) + '">' + esc(state.note || "") + '</textarea>' +
        '<div class="err">Please add a message for your gift note.</div>' +
        '</div>' +
        '</div></div>' +
        '<div class="row">' +
        '<label class="top"><input type="checkbox" class="p-on"' + (state.pri ? " checked" : "") + '><span class="t">I’m leaving soon</span><span class="ic">' + ICON_PLANE + '</span><span class="p">+$3</span></label>' +
        '<div class="sub">Get priority processing. We’ll pack yours first.</div>' +
        '</div>';
      after.parentNode.insertBefore(w, after.nextSibling);

      function readState() {
        state.on = w.querySelector(".g-on").checked;
        state.pri = w.querySelector(".p-on").checked;
        w.querySelector(".g-body").style.display = state.on ? "block" : "none";
        w.querySelectorAll(".it").forEach(function (it) {
          var k = it.getAttribute("data-k"), c = single ? state.on : it.querySelector(".g-c").checked;
          it.querySelector(".g-c").checked = c;
          state.items[k] = { c: c };
        });
        var ta = w.querySelector(".g-n textarea");
        state.note = ta.value;
        ta.placeholder = exampleFor(units);
        if (ta.value.trim()) w.querySelector(".g-n").classList.remove("bad");
      }
      w.addEventListener("change", function (e) {
        if (e.target.tagName === "TEXTAREA") return;
        /* Turning gift on with nothing ticked yet: tick everything (they untick what's not part of the gift) */
        if (e.target.classList.contains("g-on") && e.target.checked && !w.querySelector(".it .g-c:checked")) {
          w.querySelectorAll(".it .g-c").forEach(function (c) { c.checked = true; });
        }
        readState(); reconcile(units);
      });
      w.addEventListener("input", function (e) {
        if (e.target.tagName !== "TEXTAREA") return;
        readState();
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () { post("/cart/update.js", { attributes: attrsFor(units).attrs }); }, 600);
      });
    });
  }

  /* Every wrapped journal needs a message before checkout */
  function missingGiftNote(sr) {
    var w = sr.getElementById("rova-gift");
    if (!w || !w.querySelector(".g-on") || !w.querySelector(".g-on").checked) return null;
    var any = [].some.call(w.querySelectorAll(".it .g-c"), function (c) { return c.checked; });
    var n = w.querySelector(".g-n"), t = n.querySelector("textarea");
    var bad = any && !t.value.trim();
    n.classList.toggle("bad", bad);
    return bad ? t : null;
  }
  function guardCheckout(sr) {
    sr.addEventListener("click", function (e) {
      var t = e.target && e.target.closest && e.target.closest(".upcart-checkout-button-container, #upcart-express-pay-buttons-container");
      if (!t) return;
      var missing = missingGiftNote(sr);
      if (!missing) return;
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      missing.scrollIntoView({ block: "center", behavior: "smooth" });
      setTimeout(function () { try { missing.focus({ preventScroll: true }); } catch (x) {} }, 350);
    }, true);
  }

  function reconcile(units) {
    if (busy) return;
    busy = true;
    var a = attrsFor(units);
    var updates = {}; updates[GIFT_VARIANT] = a.count; updates[PRIORITY_VARIANT] = (state.pri && units.length && isUS()) ? 1 : 0;
    a.attrs["Priority processing"] = (state.pri && units.length) ? "Yes" : "";
    post("/cart/update.js", { updates: updates, attributes: a.attrs })
      .then(function () { busy = false; refresh(); })
      .catch(function () { busy = false; });
  }

  /* ---------- Premium look, clean names, badges, trust line ---------- */
  var TRUST_LINE = "Small batch · Packed by hand";
  var TOP_BAR = "Made for the trip of a lifetime";
  var PREMIUM_CSS =
    '.upcart-cart,.upcart-cart *{font-family:"Zalando Sans SemiExpanded",Assistant,sans-serif!important}' +
    '.upcart-cart{background:#FBF8F4!important;color:#2B2623}' +
    '.upcart-header{border-bottom:1px solid #EAE3DB!important;padding-top:22px!important;padding-bottom:18px!important}' +
    '.upcart-header-text{font-size:15px!important;font-weight:600!important;letter-spacing:2.5px!important;text-transform:uppercase}' +
    '.upcart-announcement{background:#8F8076!important;color:#FBF8F4!important;font-size:11.5px!important;letter-spacing:1.4px!important;text-transform:uppercase;padding:10px 12px!important;height:auto!important}' +
    '.upcart-announcement *{color:#FBF8F4!important}' +
    '#rova-bar{background:#8F8076;color:#FBF8F4;font-size:11.5px;letter-spacing:1.4px;text-transform:uppercase;text-align:center;padding:10px 12px;white-space:nowrap}' +
    '[class*="ProductRow__product__"]{border-bottom:1px solid #EAE3DB!important;padding-top:18px!important;padding-bottom:18px!important}' +
    '.upcart-product-image-wrapper{position:relative!important;width:80px!important;height:96px!important;min-width:80px;background:none!important}' +
    '.upcart-product-image-wrapper>a{position:static!important}' +
    '.upcart-product-image-wrapper img{position:absolute!important;top:0!important;bottom:0!important;left:0!important;right:0!important;width:auto!important;height:auto!important;max-width:80px!important;max-height:96px!important;object-fit:contain!important;margin:auto!important}' +
    '.upcart-product-title{font-size:14px!important;font-weight:600!important;letter-spacing:.4px!important}' +
    '.upcart-item-price{font-size:14px!important;font-weight:500!important}' +
    '[class*="QuantityField"]{border-color:#DDD3C8!important;border-radius:999px!important;background:#fff}' +
    '.upcart-footer{background:#F4EEE7!important;border-top:1px solid #EAE3DB;padding-top:12px!important;padding-bottom:10px!important}' +
    '.upcart-continue-shopping{display:none!important}' +
    '#upcart-express-pay-buttons-container .dynamic-checkout__content{margin-top:8px!important}' +
    '.upcart-checkout-button-container button,.upcart-checkout-button-container a{border-radius:999px!important;letter-spacing:1.8px!important;text-transform:uppercase;font-size:13.5px!important;height:52px!important;display:flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;padding-left:calc(1em + 1.8px)!important;padding-right:1em!important}' +
    '.upcart-savings-row{display:none!important}' +
    '#rova-savings{display:flex;justify-content:space-between;align-items:center;margin:12px 16px 0;font-size:12.5px;letter-spacing:.3px;opacity:.8}' +
    '#rova-savings .code{font-size:10px;letter-spacing:1px;text-transform:uppercase;border:1px solid #DDD3C8;border-radius:999px;padding:2px 7px;margin-left:6px}' +
    '#rova-savings .amt{font-weight:600}' +
    '.upcart-continue-shopping{font-size:12px!important;letter-spacing:.8px;opacity:.7;text-decoration:underline;text-underline-offset:3px}' +
    '#rova-trust{text-align:center;white-space:nowrap;font-size:10.5px;letter-spacing:.12em;text-transform:uppercase;opacity:.65;margin:0 0 9px}' +
    '.rova-badge{display:flex;flex-direction:column;gap:4px;margin:6px 0 2px}' +
    '.rova-badge .pill{align-self:flex-start;white-space:nowrap;font-size:min(10px,2.5vw);letter-spacing:.1em;text-transform:uppercase;font-weight:600;color:#fff;background:' + ACCENT + ';padding:3px 8px;border-radius:999px}' +
    '.rova-badge .ship{font-size:11.5px;letter-spacing:.3px;opacity:.7}';

  function cleanName(s) {
    var m = s.match(/^\s*([A-Za-z' ]+?)\s*-\s*Travel Journal\s*$/);
    if (!m) return null;
    var n = m[1].trim().toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    return n + " Travel Journal";
  }

  var badgeCache = {}, badgePending = {};
  function loadBadge(handle) {
    if (!handle || badgePending[handle]) return;
    badgePending[handle] = true;
    fetch("/products/" + handle + "?section_id=rova-gift-wrap", { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" id="rova-badge-data">([\s\S]*?)<\/script>/);
        badgeCache[handle] = m ? JSON.parse(m[1]) : {};
        decorate();
      })
      .catch(function () { badgeCache[handle] = {}; });
  }

  function decorate() {
    var sr = root(); if (!sr) return;
    if (!sr.getElementById("rova-premium")) {
      var st = document.createElement("style"); st.id = "rova-premium"; st.textContent = PREMIUM_CSS; sr.appendChild(st);
    }
    hideGiftRowControls(sr);
    setHeaderCount(sr);
    sr.querySelectorAll('[class*="ProductRow__product__"]').forEach(function (row) {
      var t = row.querySelector(".upcart-product-title"); if (!t) return;
      if (row.style.display === "none") return;
      var walker = document.createTreeWalker(t, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var nice = cleanName(walker.currentNode.nodeValue);
        if (nice) walker.currentNode.nodeValue = nice;
      }
      var link = row.querySelector('a[href*="/products/"]');
      var handle = link ? (link.getAttribute("href").split("/products/")[1] || "").split(/[?#/]/)[0] : "";
      if (handle && !(handle in badgeCache)) { loadBadge(handle); return; }
      var info = badgeCache[handle];
      var existing = row.querySelector(".rova-badge");
      var key = info ? (info.b || "") + "|" + (info.s || "") : "";
      if (existing && existing.getAttribute("data-k") === key) return;
      if (existing) existing.remove();
      if (!info || (!info.b && !info.s)) return;
      var b = document.createElement("div");
      b.className = "rova-badge"; b.setAttribute("data-k", key);
      b.innerHTML = (info.b ? '<span class="pill">' + esc(info.b) + '</span>' : "") + (info.s ? '<span class="ship">' + esc(info.s) + '</span>' : "");
      var holder = t.closest('[class*="productTitleAndVariant"]') || t.parentNode;
      holder.appendChild(b);
    });
    /* Top bar: UpCart's countdown while it runs, then our message in the same style */
    var products = sr.querySelector(".upcart-products-section");
    var bar = sr.getElementById("rova-bar");
    if (sr.querySelector(".upcart-announcement") || !products) {
      if (bar) bar.remove();
    } else {
      if (!bar) { bar = document.createElement("div"); bar.id = "rova-bar"; bar.textContent = TOP_BAR; }
      if (products.previousSibling !== bar) products.parentNode.insertBefore(bar, products);
    }
    /* Trust line sits just above Checkout */
    var btn = sr.querySelector(".upcart-checkout-button-container");
    var xp = sr.getElementById("upcart-express-pay-buttons-container");
    /* Keep Shop Pay / Apple Pay / Google Pay in one row: Shopify stacks 3 wallets under 320px,
       so lay them out at 330px and scale the row down to fit (buttons end up a bit shorter than Checkout) */
    var acc = xp && xp.querySelector("shopify-accelerated-checkout-cart");
    if (acc) {
      var W = xp.getBoundingClientRect().width;
      if (W > 0 && W < 330) {
        var z = (W / 330).toFixed(4);
        if (acc.style.zoom !== z) { acc.style.display = "block"; acc.style.width = "330px"; acc.style.zoom = z; }
      } else if (W >= 330 && acc.style.zoom) { acc.style.zoom = ""; acc.style.width = ""; acc.style.display = ""; }
    }
    if (btn) {
      var tr = sr.getElementById("rova-trust");
      if (!tr) { tr = document.createElement("div"); tr.id = "rova-trust"; tr.textContent = TRUST_LINE; }
      if (btn.previousSibling !== tr) btn.parentNode.insertBefore(tr, btn);
    }
  }

  /* ---------- Floating cart button (bottom-right, lifts above sticky bars) ---------- */
  var fab = null;
  function buildFab() {
    var st = document.createElement("style");
    st.textContent =
      '#rova-cart-fab{position:fixed;right:18px;bottom:20px;z-index:2147483000;width:56px;height:56px;border-radius:50%;border:none;background:#8F8076;color:#FBF8F4;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 6px 18px rgba(43,38,35,.22);transition:bottom .25s ease,transform .15s ease,opacity .2s ease;padding:0}' +
      '#rova-cart-fab:active{transform:scale(.94)}' +
      '#rova-cart-fab.rova-hide{opacity:0;pointer-events:none}' +
      '#rova-cart-fab svg{width:24px;height:24px}' +
      '#rova-cart-fab .ct{position:absolute;top:-3px;right:-3px;min-width:20px;height:20px;padding:0 5px;box-sizing:border-box;border-radius:999px;background:' + ACCENT + ';color:#fff;font:600 11px/16px "Zalando Sans SemiExpanded",Assistant,sans-serif;text-align:center;border:2px solid #FBF8F4}';
    document.head.appendChild(st);
    fab = document.createElement("button");
    fab.id = "rova-cart-fab"; fab.type = "button"; fab.setAttribute("aria-label", "Open cart");
    fab.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1.2 11.1a2 2 0 0 1-2 1.9H8.2a2 2 0 0 1-2-1.9L5 8z"/><path d="M9 10V6.5a3 3 0 0 1 6 0V10"/></svg><span class="ct" style="display:none"></span>';
    fab.addEventListener("click", function () { if (window.upcartOpenCart) window.upcartOpenCart(); });
    document.body.appendChild(fab);
    var ticking = false;
    function onMove() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; liftFab(); }); }
    window.addEventListener("scroll", onMove, { passive: true });
    window.addEventListener("resize", onMove);
    setInterval(findFixed, 5000);
    setTimeout(findFixed, 1500);
    if (window.upcartSubscribeCartOpened) window.upcartSubscribeCartOpened(function () { fab.classList.add("rova-hide"); });
    if (window.upcartSubscribeCartClosed) window.upcartSubscribeCartClosed(function () { fab.classList.remove("rova-hide"); });
    findFixed();
  }
  var fixedCandidates = [];
  function findFixed() {
    fixedCandidates = [];
    var all = document.body.getElementsByTagName("*");
    for (var i = 0; i < all.length; i++) {
      var e = all[i];
      if (e === fab || (fab && fab.contains(e)) || e.id === "upCart" || e.id === "PBarNextFrameWrapper") continue;
      if (getComputedStyle(e).position === "fixed") fixedCandidates.push(e);
    }
    liftFab();
  }
  function liftFab() {
    if (!fab) return;
    var off = 0;
    fixedCandidates.forEach(function (e) {
      if (!e.isConnected) return;
      var cs = getComputedStyle(e);
      if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") return;
      var r = e.getBoundingClientRect();
      if (r.height > 0 && r.height < 200 && r.width > window.innerWidth * 0.6 && r.bottom >= window.innerHeight - 2) off = Math.max(off, window.innerHeight - r.top);
    });
    fab.style.bottom = (20 + off) + "px";
  }
  var journalCount = null;
  function setHeaderCount(sr) {
    var h = sr && sr.querySelector(".upcart-header-text");
    if (!h || journalCount === null) return;
    var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      var v = walker.currentNode.nodeValue, nv = v.replace(/\(\d+\)/, "(" + journalCount + ")");
      if (nv !== v) walker.currentNode.nodeValue = nv;
    }
  }
  function setFabCount(cart) {
    var n = 0;
    cart.items.forEach(function (i) { if (!isAddon(i)) n += i.quantity; });
    journalCount = n; setHeaderCount(root());
    document.querySelectorAll("#rova-cart-fab .ct, #rova-dnav .rova-nav-cart .ct").forEach(function (ct) {
      ct.textContent = n; ct.style.display = n ? "" : "none";
    });
  }

  /* ---------- "Add to cart" under each journal in multi-journal sections (e.g. New Limited Editions) ---------- */
  function addCardButtons() {
    if (!document.getElementById("rova-atc-style")) {
      var st = document.createElement("style"); st.id = "rova-atc-style";
      st.textContent =
        'button.rova-atc{display:block!important;margin:0 auto!important;width:min(100%,170px)!important;height:38px!important;border:1px solid rgba(43,38,35,.55)!important;border-radius:999px!important;background:transparent!important;color:#2B2623!important;font-family:"Zalando Sans SemiExpanded",Assistant,sans-serif!important;font-size:10.5px!important;font-weight:600!important;line-height:36px!important;letter-spacing:.14em!important;text-transform:uppercase!important;cursor:pointer!important;padding:0 0 0 .14em!important;box-shadow:none!important;transition:background .2s ease,color .2s ease,transform .15s ease}' +
        'button.rova-atc:hover,button.rova-atc:active{background:#2B2623!important;color:#FBF8F4!important}button.rova-atc:active{transform:scale(.97)}button.rova-atc[disabled]{opacity:.6!important}' +
        '[data-rova-card]>.rova-spacer{display:block!important;flex:1 0 20px!important;min-height:20px!important}';
      document.head.appendChild(st);
    }
    document.querySelectorAll('[id^="shopify-section"]').forEach(function (sec) {
      var handles = [];
      var skip = function (a) { return a.closest("#rova-dnav, .rova-menu-drawer, .rova-mobile-nav, nav, #rova-footer"); };
      sec.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (skip(a)) return;
        var h = (a.getAttribute("href").split("/products/")[1] || "").split(/[?#/]/)[0];
        if (/-travel-journal$/.test(h) && handles.indexOf(h) < 0) handles.push(h);
      });
      if (handles.length < 3) return;
      handles.forEach(function (h) {
        var link = null;
        sec.querySelectorAll('a[href*="/products/' + h + '"]').forEach(function (a) { if (!link && !skip(a)) link = a; });
        if (!link) return;
        var c = link;
        while (c && c !== sec) {
          var hasOther = handles.some(function (x) { return x !== h && [].some.call(c.querySelectorAll('a[href*="/products/' + x + '"]'), function (a) { return !skip(a); }); });
          if (hasOther) break;
          c = c.parentElement;
        }
        if (!c) return;
        var card = link;
        while (card.parentElement && card.parentElement !== c) card = card.parentElement;
        if (card.querySelector(".rova-atc")) return;
        card.setAttribute("data-rova-card", h);
        var sp = document.createElement("div"); sp.className = "rova-spacer"; card.appendChild(sp);
        var b = document.createElement("button");
        b.type = "button"; b.className = "rova-atc"; b.textContent = "Add to cart";
        b.addEventListener("click", function () {
          b.disabled = true; b.textContent = "Adding…";
          fetch("/products/" + h + ".js").then(function (r) { return r.json(); }).then(function (p) {
            return fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: 1 }] }) });
          }).then(function (r) {
            if (!r.ok) throw new Error("add failed");
            refresh(); if (window.upcartOpenCart) window.upcartOpenCart();
            b.textContent = "Added ✓";
          }).catch(function () { b.textContent = "Try again"; })
            .then(function () { setTimeout(function () { b.textContent = "Add to cart"; b.disabled = false; }, 1800); });
        });
        card.appendChild(b);
      });
    });
  }

  /* ---------- Desktop navigation (990px+), links either side of the centered logo ---------- */
  /* ONE list of journals for both menus. To add a journal, add a line here. */
  var JOURNALS = [
    { name: "Japan",  url: "/products/japan-travel-journal",  region: "Asia" },
    { name: "Bali",   url: "/products/bali-travel-journal",   region: "Asia",           isNew: true },
    { name: "Italy",  url: "/products/italy-travel-journal",  region: "Europe Edition", isNew: true },
    { name: "France", url: "/products/france-travel-journal", region: "Europe Edition", isNew: true }
  ];
  var INFO_LINKS = [
    { name: "Destination Request", url: "/pages/destination-request" },
    { name: "FAQ", url: "/pages/faq" },
    { name: "About", url: "/pages/about" },
    { name: "Contact", url: "/pages/contact-us" }
  ];
  function journalLink(j) { return '<a href="' + j.url + '">' + j.name + (j.isNew ? ' <span class="tag">NEW</span>' : '') + '</a>'; }
  function desktopMenuHtml() {
    var h = "", last = null;
    JOURNALS.forEach(function (j) { if (j.region !== last) { h += '<div class="lbl">' + j.region + '</div>'; last = j.region; } h += journalLink(j); });
    return h;
  }
  var DNAV_HTML =
    '<div class="grp"><div class="dd"><span tabindex="0">Shop Journals<svg viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M1 1l4 4 4-4"/></svg></span>' +
    '<div class="menu">' + desktopMenuHtml() + '</div></div>' +
    '<a href="/pages/destination-request">Destination Request</a></div>' +
    '<div class="grp"><a href="/pages/faq">FAQ</a><a href="/pages/about">About</a><a href="/pages/contact-us">Contact</a>' +
    '<a href="/cart" class="rova-nav-cart" aria-label="Open cart"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1.2 11.1a2 2 0 0 1-2 1.9H8.2a2 2 0 0 1-2-1.9L5 8z"/><path d="M9 10V6.5a3 3 0 0 1 6 0V10"/></svg><span class="ct" style="display:none"></span></a></div>';
  function buildDesktopNav() {
    var logo = null;
    document.querySelectorAll('[id*="global_section_635176820861305540"] img, img').forEach(function (i) { if (!logo && /Rova_logo/.test(i.src)) logo = i; });
    if (!logo) return false;
    var bar = logo.closest(".gsWIZlNk7n") || logo.parentElement;
    while (bar && bar !== document.body && !bar.classList.contains("gsWIZlNk7n")) {
      if (getComputedStyle(bar).backgroundColor === "rgb(156, 143, 133)" && bar.getBoundingClientRect().width > window.innerWidth * 0.6) break;
      bar = bar.parentElement;
    }
    if (!bar || bar === document.body) return false;
    if (!document.getElementById("rova-dnav-style")) {
      var F = '"Zalando Sans Expanded",Assistant,sans-serif';
      var st = document.createElement("style"); st.id = "rova-dnav-style";
      st.textContent =
        '#rova-dnav{position:absolute;left:0;right:0;z-index:50;display:flex;justify-content:space-between;align-items:center;padding:0 clamp(28px,4vw,64px);pointer-events:none;transform:translateY(-50%)}' +
        '#rova-dnav .grp{display:flex;gap:clamp(24px,2.8vw,44px);align-items:center;pointer-events:auto}' +
        '#rova-dnav a,#rova-dnav .dd>span{color:#FBF8F4!important;text-decoration:none!important;font-family:' + F + '!important;font-size:15px;font-weight:400;letter-spacing:.5px;cursor:pointer;padding:10px 0;position:relative;white-space:nowrap}' +
        '#rova-dnav a:after,#rova-dnav .dd>span:after{content:"";position:absolute;left:0;right:0;bottom:5px;height:1px;background:#FBF8F4;transform:scaleX(0);transform-origin:left;transition:transform .25s ease}' +
        '#rova-dnav a:hover:after,#rova-dnav .dd:hover>span:after{transform:scaleX(1)}' +
        '#rova-dnav .dd{position:relative}' +
        '#rova-dnav .dd>span{display:inline-flex;align-items:center}#rova-dnav .dd>span svg{flex:none;width:10px;height:10px;margin-left:8px}' +
        '#rova-dnav .menu{position:absolute;top:100%;left:-20px;min-width:240px;background:#FBF8F4;border-radius:10px;box-shadow:0 12px 30px rgba(43,38,35,.18);padding:0 0 6px;overflow:hidden;opacity:0;visibility:hidden;transform:translateY(6px);transition:opacity .2s ease,transform .2s ease,visibility .2s}' +
        '#rova-dnav .dd:hover .menu,#rova-dnav .dd:focus-within .menu{opacity:1;visibility:visible;transform:none}' +
        '#rova-dnav .menu a{display:flex;justify-content:space-between;align-items:center;color:#2B2623!important;padding:10px 20px;font-size:14px;letter-spacing:.4px}' +
        '#rova-dnav .menu a:after{display:none}#rova-dnav .menu a:hover{background:#F4EEE7}' +
        '#rova-dnav .menu .tag{font-size:10px;letter-spacing:.6px;color:' + ACCENT + ';font-weight:600;font-family:' + F + '}' +
        '#rova-dnav .menu .lbl{background:#EFE7DE;color:#6F6258;padding:8px 20px;margin:0 0 4px;font-size:11px;font-weight:600;letter-spacing:.8px;font-family:' + F + '}' +
        '#rova-dnav .menu .lbl~.lbl{margin-top:6px}' +
        '#rova-dnav a.rova-nav-cart{display:inline-flex;align-items:center;position:relative;padding:6px 2px}#rova-dnav a.rova-nav-cart:after{display:none}' +
        '#rova-dnav a.rova-nav-cart svg{width:22px;height:22px;transition:transform .2s ease}#rova-dnav a.rova-nav-cart:hover svg{transform:translateY(-1px)}' +
        '#rova-dnav a.rova-nav-cart .ct{position:absolute;top:-2px;right:-10px;min-width:18px;height:18px;padding:0 5px;box-sizing:border-box;border-radius:999px;background:' + ACCENT + ';color:#fff;font:600 10px/18px ' + F + ';letter-spacing:0;text-align:center}' +
        '@media (min-width:990px){html.rova-has-dnav #rova-cart-fab{display:none!important}}' +
        '@media (max-width:989px){#rova-dnav{display:none!important}}';
      document.head.appendChild(st);
    }
    var n = document.getElementById("rova-dnav");
    if (!n) {
      n = document.createElement("nav"); n.id = "rova-dnav"; n.setAttribute("aria-label", "Main");
      n.innerHTML = DNAV_HTML;
      if (getComputedStyle(bar).position === "static") bar.style.position = "relative";
      bar.appendChild(n);
      n.querySelector(".rova-nav-cart").addEventListener("click", function (e) {
        if (window.upcartOpenCart) { e.preventDefault(); window.upcartOpenCart(); }
      });
      document.documentElement.classList.add("rova-has-dnav");
      getCart().then(setFabCount);
    }
    function place() {
      var br = bar.getBoundingClientRect(), lr = logo.getBoundingClientRect();
      if (lr.height) n.style.top = (lr.top - br.top + lr.height / 2) + "px";
    }
    place();
    if (logo.complete === false) logo.addEventListener("load", place);
    window.addEventListener("resize", place);
    setTimeout(place, 1500);
    /* keep it locked to the logo if the header shifts while loading or scrolling */
    var placing = false;
    window.addEventListener("scroll", function () { if (placing) return; placing = true; requestAnimationFrame(function () { placing = false; place(); }); }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(place).observe(bar);
    return true;
  }

  /* ---------- Mobile menu: fills the existing drawer (.rova-menu-links) from the same lists ---------- */
  function buildMobileNav() {
    var links = document.querySelector(".rova-mobile-nav .rova-menu-links");
    if (!links) return false;
    if (links.classList.contains("rova-mnav")) return true;
    if (!document.getElementById("rova-mnav-style")) {
      var F = '"Zalando Sans Expanded",Assistant,sans-serif';
      var st = document.createElement("style"); st.id = "rova-mnav-style";
      st.textContent =
        '.rova-menu-links.rova-mnav{border-top:0!important}' +
        '.rova-mnav .lbl{font-family:' + F + ';font-size:11px;font-weight:600;letter-spacing:1.6px;text-transform:uppercase;color:#8F8076;padding:0 2px 10px}' +
        '.rova-mnav .lbl2{margin-top:30px}' +
        '.rova-mnav .j a{display:flex!important;align-items:center;justify-content:space-between;border-bottom:0!important;border-top:1px solid rgba(65,55,45,.25)!important;padding:16px 2px!important;font-size:18px!important;font-weight:500!important;color:rgb(65,55,45)!important}' +
        '.rova-mnav .j a:last-child{border-bottom:1px solid rgba(65,55,45,.25)!important}' +
        '.rova-mnav .arr{display:flex;align-items:center;gap:12px}.rova-mnav .arr svg{width:8px;height:12px;flex:none}' +
        '.rova-mnav .tag{font-family:' + F + ';font-size:10px;font-weight:600;letter-spacing:.6px;color:' + ACCENT + '}' +
        '.rova-mnav .i a{display:block!important;border-bottom:0!important;padding:12px 2px!important;font-size:16.5px!important;font-weight:400!important;color:rgb(65,55,45)!important}' +
        'body.rova-menu-open #rova-cart-fab{opacity:0!important;pointer-events:none!important}' +
        '@media (min-width:990px){html.rova-has-dnav .rova-mobile-nav{display:none!important}}';
      document.head.appendChild(st);
    }
    var ARR = '<svg viewBox="0 0 8 12" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M1 1l5 5-5 5"/></svg>';
    var h = '<div class="lbl">Journals</div><div class="j">';
    JOURNALS.forEach(function (j) { h += '<a href="' + j.url + '">' + j.name + '<span class="arr">' + (j.isNew ? '<span class="tag">NEW</span>' : '') + ARR + '</span></a>'; });
    h += '</div><div class="lbl lbl2">More</div><div class="i">';
    /* Mobile order: FAQ, About, Contact, then Destination Request */
    INFO_LINKS.slice(1).concat(INFO_LINKS[0]).forEach(function (l) { h += '<a href="' + l.url + '">' + l.name + '</a>'; });
    links.innerHTML = h + '</div>';
    links.classList.add("rova-mnav");
    return true;
  }

  /* ---------- Footer (Home, FAQ, About, Contact: pages that have the full GemPages footer) ---------- */
  var FOOTER_TAGLINE = "Your phone will die. Your stories won't.";
  var SOCIAL = { instagram: "https://www.instagram.com/rova.journal/", tiktok: "https://www.tiktok.com/@rovajournal" };   /* full profile URLs; an icon shows only when filled in */
  var LOGO_URL = "https://cdn.shopify.com/s/files/1/0994/5455/0302/files/Rova_logo_3.png";
  var STRIP_URL = "https://cdn.shopify.com/s/files/1/0994/5455/0302/files/black_footer.png";
  var OLD_FOOTER_DESK = '[id*="global_section_635196607893078803"]';
  var OLD_FOOTER_MOB = '[id*="global_section_635195599280407058"]';
  function logoBox(w) {
    /* the logo file has empty space around the word; crop to the word at width w */
    var s = w / 734;
    return '<a href="/" class="rf-logo" aria-label="Rova home" style="width:' + w + 'px;height:' + Math.round(212 * s) + 'px;background-image:url(' + LOGO_URL + ');background-size:' + (1280 * s).toFixed(1) + 'px auto;background-position:-' + (272 * s).toFixed(1) + 'px -' + (294 * s).toFixed(1) + 'px"></a>';
  }
  function socialHtml() {
    var h = "";
    if (SOCIAL.instagram) h += '<a href="' + SOCIAL.instagram + '" target="_blank" rel="noopener" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r=".8" fill="currentColor"/></svg></a>';
    if (SOCIAL.tiktok) h += '<a href="' + SOCIAL.tiktok + '" target="_blank" rel="noopener" aria-label="TikTok"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5"/><path d="M14 3c.5 2.5 2.5 4.5 5 4.5"/></svg></a>';
    return h ? '<div class="rf-soc">' + h + '</div>' : "";
  }
  function buildFooter() {
    var oldDesk = document.querySelector(OLD_FOOTER_DESK), oldMob = document.querySelector(OLD_FOOTER_MOB);
    if (!oldMob || !oldDesk) return !!document.body;   /* product pages etc. keep their own footer */
    if (document.getElementById("rova-footer")) return true;
    fetch(location.pathname + "?section_id=rova-footer-data", { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (document.getElementById("rova-footer")) return;
        var tmp = document.createElement("div"); tmp.innerHTML = html;
        var data = tmp.querySelector("#rova-footer-data");
        /* show only the payment icons shoppers recognize most */
        var PAY_KEEP = ["pi-visa", "pi-master", "pi-american_express", "pi-apple_pay", "pi-google_pay", "pi-shopify_pay"];
        var pay = "";
        if (data) data.querySelectorAll("svg").forEach(function (s) { if (PAY_KEEP.indexOf(s.getAttribute("aria-labelledby")) >= 0) pay += s.outerHTML; });
        var privacy = (data && data.getAttribute("data-privacy")) || "/policies/privacy-policy";
        var year = (data && data.getAttribute("data-year")) || new Date().getFullYear();
        var F = '"Zalando Sans Expanded",Assistant,sans-serif';
        if (!document.getElementById("rova-footer-style")) {
          var st = document.createElement("style"); st.id = "rova-footer-style";
          st.textContent =
            '#rova-footer{font-family:' + F + ';color:#FBF8F4;background:#9C8F85}' +
            '#rova-footer a{color:inherit!important;text-decoration:none!important}' +
            '#rova-footer .rf-strip{display:block!important;width:100%;aspect-ratio:48/1;min-height:14px;background:url(' + STRIP_URL + ') center/cover no-repeat;position:relative;z-index:2;box-shadow:0 -2px 6px rgba(43,38,35,.18),0 4px 10px rgba(43,38,35,.35)}' +
            '#rova-footer .rf-logo{display:block;background-repeat:no-repeat}' +
            '#rova-footer .lbl{font-size:11px;font-weight:600;letter-spacing:1.6px;text-transform:uppercase;opacity:.75}' +
            '#rova-footer .tag{font-size:9.5px;font-weight:600;letter-spacing:.6px;color:#F6D6DC;margin-left:7px}' +
            '#rova-footer .rf-pay{display:flex;gap:6px;flex-wrap:wrap}#rova-footer .rf-pay svg{height:24px;width:auto;display:block}' +
            '#rova-footer .rf-soc{display:flex;gap:16px}#rova-footer .rf-soc svg{width:20px;height:20px;display:block}' +
            '#rova-footer .rf-small{font-size:12px;display:flex;gap:18px;align-items:center;opacity:.9}' +
            '#rova-footer .rf-desk{max-width:1320px;margin:0 auto;padding:60px clamp(28px,5vw,80px) 0}' +
            '#rova-footer .rf-top{display:grid;grid-template-columns:1.4fr 1fr 1fr 1fr;gap:40px;padding-bottom:48px}' +
            '#rova-footer .rf-brand p{font-size:14px;line-height:1.55;margin:16px 0 22px;opacity:.9;max-width:300px}' +
            '#rova-footer .rf-col .lbl{margin-bottom:18px}' +
            '#rova-footer .rf-col a{display:flex;align-items:center;font-size:15px;margin-bottom:13px;width:max-content}' +
            '#rova-footer .rf-col a:hover,#rova-footer .rf-row a:hover,#rova-footer .rf-small a:hover{text-decoration:underline!important;text-underline-offset:4px}' +
            '#rova-footer .rf-bot{display:flex;justify-content:space-between;align-items:center;border-top:1px solid rgba(251,248,244,.3);padding:20px 0 28px}' +
            '#rova-footer .rf-mob{display:none;text-align:center;padding:30px 24px 30px}' +
            '#rova-footer .rf-mob .rf-logo{margin:0 auto 24px}' +
            '#rova-footer .rf-mob .lbl{margin-bottom:6px}' +
            '#rova-footer .rf-row{font-size:14.5px;line-height:1.9}' +
            '#rova-footer .rf-row .dot{opacity:.6;margin:0 8px}' +
            '#rova-footer .rf-mob .rf-sec+.rf-sec{margin-top:18px}' +
            '#rova-footer .rf-mob .rf-soc{justify-content:center;margin-top:20px}' +
            '#rova-footer .rf-mob .rf-pay{justify-content:center;margin:24px 0 14px}' +
            '#rova-footer .rf-mob .rf-small{justify-content:center;flex-wrap:wrap;font-size:11.5px}' +
            '@media (max-width:989px){#rova-footer .rf-desk{display:none}#rova-footer .rf-mob{display:block}}' +
            'html.rova-has-footer ' + OLD_FOOTER_DESK + ',html.rova-has-footer ' + OLD_FOOTER_MOB + '{display:none!important}';
          document.head.appendChild(st);
        }
        var dot = '<span class="dot">&middot;</span>';
        var jLinks = JOURNALS.map(function (j) { return '<a href="' + j.url + '">' + j.name + (j.isNew ? '<span class="tag">NEW</span>' : '') + '</a>'; }).join("");
        var small = '<div class="rf-small"><a href="' + privacy + '">Privacy</a><span>&copy; ' + year + ' Rova</span></div>';
        var f = document.createElement("footer");
        f.id = "rova-footer";
        f.innerHTML =
          '<div class="rf-strip"></div>' +
          '<div class="rf-desk"><div class="rf-top">' +
            '<div class="rf-brand">' + logoBox(150) + '<p>' + esc(FOOTER_TAGLINE).replace(". ", ".<br>") + '</p>' + socialHtml() + '</div>' +
            '<div class="rf-col"><div class="lbl">Journals</div>' + jLinks + '</div>' +
            '<div class="rf-col"><div class="lbl">Help</div><a href="/pages/faq">FAQ</a><a href="/pages/contact-us">Contact</a></div>' +
            '<div class="rf-col"><div class="lbl">Rova</div><a href="/pages/about">About</a><a href="/pages/destination-request">Destination Request</a></div>' +
          '</div><div class="rf-bot">' + small + '<div class="rf-pay">' + pay + '</div></div></div>' +
          '<div class="rf-mob">' + logoBox(120) +
            '<div class="rf-sec"><div class="lbl">Journals</div><div class="rf-row">' +
              JOURNALS.map(function (j) { return '<a href="' + j.url + '">' + j.name + '</a>'; }).join(dot) + '</div></div>' +
            '<div class="rf-sec"><div class="lbl">More</div><div class="rf-row"><a href="/pages/faq">FAQ</a>' + dot + '<a href="/pages/about">About</a>' + dot + '<a href="/pages/contact-us">Contact</a><br><a href="/pages/destination-request">Destination Request</a></div></div>' +
            socialHtml() +
            '<div class="rf-pay">' + pay + '</div>' + small +
          '</div>';
        oldDesk.parentNode.insertBefore(f, oldDesk);
        document.documentElement.classList.add("rova-has-footer");
      })
      .catch(function () {});
    return true;
  }
  function footerWhenReady(tries) { if (!buildFooter() && tries < 20) setTimeout(function () { footerWhenReady(tries + 1); }, 300); }

  var drawTimer = null;
  function scheduleDraw() {
    clearTimeout(drawTimer);
    drawTimer = setTimeout(function () {
      var sr = root();
      if (sr && sr.querySelector(".upcart-products-section")) draw();
      else getCart().then(setFabCount);
    }, 250);
  }

  /* ---------- Sticky "Buy now" bar: press the button connected to the Kaching bundle picker ---------- */
  function shown(e) { var r = e.getBoundingClientRect(); return r.width > 0 && r.height > 0 && getComputedStyle(e).visibility !== "hidden"; }
  document.addEventListener("click", function (e) {
    var s = e.target && e.target.closest && e.target.closest("gp-sticky .gp-button-atc");
    if (!s) return;
    var main = null;
    document.querySelectorAll("kaching-bundles-block").forEach(function (k) {
      if (main || !shown(k)) return;
      var f = k.closest("form"); if (!f) return;
      f.querySelectorAll("button.gp-button-atc").forEach(function (b) { if (!main && !b.closest("gp-sticky") && shown(b)) main = b; });
    });
    if (!main) return;
    e.preventDefault(); e.stopImmediatePropagation();
    main.click();
  }, true);

  function init() {
    var sr = root();
    if (!sr || !window.upcartSubscribeCartUpdated) return setTimeout(init, 300);
    ["upcartSubscribeCartUpdated", "upcartSubscribeCartLoaded", "upcartSubscribeCartOpened", "upcartSubscribeItemRemoved", "upcartSubscribeAddedToCart"]
      .forEach(function (f) { if (window[f]) window[f](scheduleDraw); });
    var decoTimer = null;
    new MutationObserver(function () {
      if (sr.querySelector(".upcart-products-section") && !sr.getElementById("rova-gift")) scheduleDraw();
      clearTimeout(decoTimer); decoTimer = setTimeout(decorate, 30);
    }).observe(sr, { childList: true, subtree: true, characterData: true });
    guardCheckout(sr);
    decorate();
    buildFab();
    addCardButtons();
    setTimeout(addCardButtons, 1500);
    setTimeout(addCardButtons, 4000);
    getCart().then(setFabCount);
    scheduleDraw();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
